import {
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { HeaderComponent } from "@components/header/header.component";
import { InputComponent } from "@components/input/input.component";
import { TableComponent } from "@components/table/table.component";
import { Anskaffningsformer } from "~app/common/models/constants";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { IArbetsorderDetail } from "~app/features/planera/model/IArbetsorderDetail";
import { IAtgard } from "~app/features/planera/model/IAtgard";
import { ArbetsorderTradslagsdataViewModel, ITradslagsdataResponse } from "./arbetsorder-tradslagsdata.models";
import { ArbetsorderTradslagsdataService } from "./arbetsorder-tradslagsdata.service";

@Component({
    selector: "rask-arbetsorder-tradslagsdata",
    templateUrl: "./arbetsorder-tradslagsdata.component.html",
    styleUrls: ["./arbetsorder-tradslagsdata.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        InputComponent,
        HeaderComponent,
        TableComponent
    ]
})
export class ArbetsorderTradslagsdataComponent implements OnChanges {
    @Input() arbetsorder: IArbetsorderDetail;
    @Input() atgard: IAtgard;
    isEnabledForSelection: boolean;
    viewModel: ArbetsorderTradslagsdataViewModel;

    private readonly tradslagsdataService = inject(ArbetsorderTradslagsdataService);

    private hasAtgard: boolean;

    ngOnChanges(changes: SimpleChanges): void {
        this.viewModel = undefined;

        if (changes.arbetsorder &&
            (changes.arbetsorder.firstChange || changes.arbetsorder?.previousValue?.id !== changes.arbetsorder?.currentValue?.id)) {
            this.isEnabledForSelection = this.arbetsorder &&
            !Anskaffningsformer.isVirkesKop(this.arbetsorder.anskaffningsform);
        }

        if (changes.atgard &&
            (changes.atgard.firstChange || changes.atgard?.previousValue?.id !== changes.atgard?.currentValue?.id)) {
            this.hasAtgard = !ObjectUtils.isNullOrUndefined(this.atgard);
        }

        this.loadTradslagsdata();
    }

    private loadTradslagsdata(): void {
        if (!this.isEnabledForSelection) {
            this.viewModel = new ArbetsorderTradslagsdataViewModel(this.arbetsorder, this.atgard);
            return;
        }

        const handler = (response: ITradslagsdataResponse) => {
            this.viewModel = new ArbetsorderTradslagsdataViewModel(this.arbetsorder, this.atgard, response);
        };

        if (this.hasAtgard) {
            this.tradslagsdataService.getTradslagsdataForAtgard(this.atgard.id).subscribe(handler);
        } else {
            this.tradslagsdataService.getTradslagsdataForArbetsorder(this.arbetsorder.id).subscribe(handler);
        }
    }
}
